module.exports = __webpack_public_path__ + "img/about-2.532b109d.jpg";